import React from "react";
import styled from "styled-components";
import { Button } from "@/react/styled";
import { ArrowLeftFullIcon, ArrowRightFullIcon } from "@8x8/oxygen-icon";

const ButtonWithIcon = styled(Button)`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const PaginationControlsContainer = styled.div`
  display: flex;
  gap: 36px;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 40px;
`;

const StyledArrowLeftFullIcon = styled(ArrowLeftFullIcon)`
  fill: currentColor;
`;

const StyledArrowRightFullIcon = styled(ArrowRightFullIcon)`
  fill: currentColor;
`;

const PaginationControls = ({ page, setPage, maxPages }) =>
  maxPages > 1 && (
    <PaginationControlsContainer>
      <ButtonWithIcon
        onClick={() => setPage((prevPage) => prevPage - 1)}
        isDisabled={page === 1}
        variant={"tertiary"}
      >
        <StyledArrowLeftFullIcon style={{ fill: "currentColor" }} />
        <span>Previous</span>
      </ButtonWithIcon>
      <span>
        Page {page}/{maxPages}
      </span>
      <ButtonWithIcon
        onClick={() => setPage((prevPage) => prevPage + 1)}
        isDisabled={page === maxPages}
        variant={"tertiary"}
      >
        <span>Next</span>
        <StyledArrowRightFullIcon style={{ fill: "currentColor" }} />
      </ButtonWithIcon>
    </PaginationControlsContainer>
  );

export default PaginationControls;
